import { useContext, useEffect, useRef } from 'react';
import recordingGif from "./images/recording.gif";
import addMessage from './utils/addMessage';
import EventListener from './utils/EventListeners';
import mikrafon from './images/mikrafon.webp';
import { AppContext } from './Context/Context';

const STT = ({ chatbotSocket, setMessages, setTyping }) => {
  const mediaRecorderRef = useRef(null);
  const socketRef = useRef(null);
  let chunks = [];
  const { handleSendChat } = useContext(AppContext);

  useEffect(() => {
    const bot = localStorage.getItem('BOT');
    const lang =
      bot === "wss://auditaibot.soof.uz/ws/audit" ? "en" : "uz";

    // faqat bir marta WebSocket ochamiz
    socketRef.current = new WebSocket(
      `wss://stt.soof.uz/ws/stt?accept_language=${lang}`
    );

    const socket = socketRef.current;

    socket.onopen = () => {
      console.log("STT WebSocket ochildi ✅");
    };

    socket.onmessage = async (event) => {
      if (event.data === "Speech not understood") {
        addMessage(
          "Tushunolmadim, qayta gapira olasizmi?",
          "",
          setMessages
        );
      } else {
        setTyping(true);

        // 🔑 Avval handleSendChat chaqiriladi va chatId olinadi
        const currentChatId = await handleSendChat({
          owner: "user",
          content: event.data
        });

        // UI ga qo‘shamiz
        addMessage({ owner: "user", content: event.data }, setMessages);

        // 🔥 chatId bor bo‘lsa keyin socketga yuboramiz
        if (currentChatId && currentChatId > 0) {
          if (chatbotSocket && chatbotSocket.readyState === WebSocket.OPEN) {
            chatbotSocket.send(
              JSON.stringify({ owner: "user", content: event.data })
            );
          } else {
            console.warn("chatbotSocket ulanmagan yoki yopilgan ❌");
          }
        }
      }
    };

    socket.onerror = (error) => {
      console.error("STT WebSocket xatoligi:", error);
    };

    socket.onclose = (event) => {
      console.log("STT WebSocket yopildi", event);
    };

    // 🔹 microphone setup
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        const mediaRecorder = new MediaRecorder(stream, {
          mimeType: "audio/webm",
        });
        mediaRecorderRef.current = mediaRecorder;

        mediaRecorder.onstart = () => {
          document.getElementById("state-icon").src = recordingGif;
          document.getElementById("recording-sound").play();
        };

        mediaRecorder.ondataavailable = (event) => {
          chunks.push(event.data);
        };

        mediaRecorder.onstop = () => {
          document.getElementById("state-icon").src = mikrafon;
          document.getElementById("stop-recording-sound").play();

          const combinedBlob = new Blob(chunks, { type: "audio/webm" });
          chunks = [];

          if (
            socketRef.current &&
            socketRef.current.readyState === WebSocket.OPEN
          ) {
            socketRef.current.send(combinedBlob);
            console.log("STT serverga yuborildi ✅");
          } else {
            console.warn("STT socket hali ulanmagan ❌");
          }
        };
      })
      .catch((error) => {
        console.error("Microphone error:", error);
      });

    // cleanup
    return () => {
      if (socketRef.current) {
        socketRef.current.close();
      }
    };
  }, [chatbotSocket, setMessages, setTyping, handleSendChat]);

  return <EventListener mediaRecorderRef={mediaRecorderRef} />;
};

export default STT;
